import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index' //直接导入store对象
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: '首页',
        component: () => import('@/views/index/home/index.vue')
      },
      {
        path: 'introduction',
        name: '公司简介',
        component: () => import('@/views/index/introduction/index.vue')
      },
      {
        path: '/introductionDetails',
        name: '公司动态详情',
        component: () => import('@/views/index/introduction/components/detail/index.vue')
      },
      {
        path: 'announcement',
        name: '公示公告',
        component: () => import('@/views/index/announcement/index.vue')
      },
      {
        path: '/announcementDetails/:projectId',
        name: '公告详情',
        component: () => import('@/views/index/announcement/components/detail/index.vue')
      },
      {
        path: '/contactUs',
        name: '联系我们',
        component: () => import('@/views/index/contactUs/index.vue')
      },
      {
        path: '/Policy',
        name: '政策法规',
        component: () => import('@/views/index/Policy/index.vue')
      },
      {
        path: '/PolicyDetails',
        name: '政策法规详情',
        component: () => import('@/views/index/Policy/components/detail/index.vue')
      },
      {
        path: '/Registration',
        name: '注册',
        component: () => import('@/views/index/Register/index.vue')
      },
      {
        path: '/personalCenter',
        name: '个人中心',
        component: () => import('@/views/index/personalCenter/index.vue')
      },
      {
        path: '/Detail',
        name: '详情',
        component: () => import('@/views/index/Detail/index.vue')
      },
      {
        path: '/more',
        name: '更多',
        component: () => import('@/views/index/More/index.vue')
      },
      {
        path: '/searchRes',
        name: '搜索结果',
        component: () => import('@/views/index/searchRes/index.vue')
      }
    ]
  },

  {
    path: '/Login',
    name: '登录',
    component: () => import('@/views/Login/index.vue')
  }
  // {
  //   path: '/registration',
  //   name: 'registration',
  //   meta: {
  //     keepAlive: true
  //   },
  //   component: () => import('@/views/registration/registration.vue')
  // },
  // {
  //   path: '/expertRegistration',
  //   name: 'expertRegistration',
  //   component: () => import('@/views/registration/expertRegistration.vue')
  // },
  // {
  //   path: '/personalCenter',
  //   name: 'personalCenter',
  //   // redirect: '/account',
  //   component: () => import('@/views/index/personalCenter/refuseCom.vue')
  // children: [
  //   {
  //     path: '/account',
  //     name: 'account',
  //     component: () => import('@/views/index/personalCenter/components/accountCom'),
  //   },
  //   {
  //     path: '/application',
  //     name: 'application',
  //     component: () => import('@/views/index/personalCenter/components/applicationCom'),
  //   },
  // ]
  // }
]

const router = new VueRouter({
  // mode: 'history',
  base: '',
  routes
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err)
}

router.beforeEach(async (to, from, next) => {
  next()
})

// 全局路由后置守卫
router.afterEach((to, from) => {
  // console.log('跳转结束')
})
export default router
